import CoreAPIService from '../../../utils/core-api';
import { fetchAction } from '../../actions';

export const name: string = 'generic';

export enum EntityName {
    COMPANIES = 'companies',
    PARTNERS = 'partners',
    DRIVERS = 'drivers',
    RIDERS = 'riders',
    MANAGERS = 'managers',
}

export const types = {
    GET_COMMENT: name + '/GET_COMMENT',
    DELETE_COMMENT: name + '/DELETE_COMMENT',
    SAVE_COMMENT: name + '/SAVE_COMMENT',
};

interface GenericState {
    comments: { [id: string]: { comment: string } };
}

const initialState: GenericState = {
    comments: {},
};

const reducer = (state = initialState, action): GenericState => {
    const payload = action.payload;
    const parameters = action.parameters;

    const id = parameters?.id ?? 0;
    const entity = parameters?.entity ?? 'ukn';
    const comment = parameters?.comment ?? '';

    switch (action.type) {
        case types.GET_COMMENT:
            return {
                ...state,
                comments: {
                    ...state.comments,
                    [`${entity}-${id}`]: {
                        comment: JSON.parse(payload[0].history?.newValue)?.comment,
                    },
                },
            };
        case types.DELETE_COMMENT:
        case types.SAVE_COMMENT:
            return {
                ...state,
                comments: {
                    ...state.comments,
                    [`${entity}-${id}`]: {
                        comment,
                    },
                },
            };
        default:
            return state;
    }
};
export default reducer;

export const actions = {
    getComment: (entityName: EntityName, entityId: string, callback) =>
        fetchAction(
            CoreAPIService.get(`/core/${entityName}/${entityId}/comment`),
            types.GET_COMMENT,
            {
                entity: entityName,
                id: entityId,
            },
            {
                success: (dispatch, data) => {
                    callback(JSON.parse(data.payload[0].history?.newValue)?.comment);
                },
            },
        ),
    saveComment: (entityName: EntityName, entityId: string, payload) =>
        fetchAction(CoreAPIService.post(`/core/${entityName}/${entityId}/comment`, payload), types.SAVE_COMMENT, {
            entity: entityName,
            id: entityId,
            comment: payload.comment,
        }),
    deleteComment: (entityName: EntityName, entityId: string, commentId: string) =>
        fetchAction(
            CoreAPIService.delete(`/core/${entityName}/${entityId}/comment/${commentId}`),
            types.DELETE_COMMENT,
            { entity: entityName, id: entityId },
        ),
};

const localState = (state: any): GenericState => state[name] || initialState;
export const selectors = {
    allComments: (state) => localState(state).comments || {},
    entityComment: (state, entity, id) => localState(state).comments?.[`${entity}-${id}`]?.comment || '',
};
